import React from 'react';
import { createPortal } from 'react-dom';
import { X, Database, AlertCircle, Save, Globe, Smartphone } from 'lucide-react';
import { isNativeApp } from '../../utils/platformUtils';

const DataStorageInfoModal = ({ isOpen, onClose, onExport }) => {
    if (!isOpen) return null;

    const isNative = isNativeApp();

    return createPortal(
        <div className="fixed inset-0 bg-black/60 z-[100000] flex items-center justify-center p-4 backdrop-blur-sm animate-fade-in">
            <div className="bg-white dark:bg-gray-800 w-full max-w-xs rounded-2xl p-4 shadow-2xl relative border border-gray-100 dark:border-gray-700">
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 p-1.5 rounded-full bg-gray-100 dark:bg-gray-700 text-gray-500 hover:text-red-500 transition-colors"
                >
                    <X size={16} />
                </button>

                <div className="flex items-center gap-3 mb-4">
                    <div className="bg-blue-100 dark:bg-blue-900/30 w-10 h-10 rounded-xl flex items-center justify-center text-blue-600 dark:text-blue-400">
                        <Database size={20} />
                    </div>
                    <div>
                        <h3 className="text-base font-bold text-gray-900 dark:text-white">Seus Dados</h3>
                        {isNative && (
                            <span className="text-[10px] text-green-600 dark:text-green-400 font-bold">📱 App Android</span>
                        )}
                    </div>
                </div>

                <div className="space-y-2 mb-4">
                    {isNative ? (
                        <>
                            <div className="bg-green-50 dark:bg-green-900/20 p-2.5 rounded-lg border border-green-100 dark:border-green-800">
                                <p className="text-xs text-green-700 dark:text-green-300">
                                    <Smartphone size={12} className="inline mr-1" />
                                    <strong>Local + Nuvem:</strong> Salvos no celular e sincronizados automaticamente quando logado.
                                </p>
                            </div>

                            <div className="bg-blue-50 dark:bg-blue-900/20 p-2.5 rounded-lg border border-blue-100 dark:border-blue-800">
                                <p className="text-xs text-blue-700 dark:text-blue-300">
                                    <Globe size={12} className="inline mr-1" />
                                    <strong>Sync:</strong> A cada 5 min seus dados vão para a nuvem automaticamente.
                                </p>
                            </div>

                            <div className="bg-orange-50 dark:bg-orange-900/20 p-2.5 rounded-lg border border-orange-100 dark:border-orange-800">
                                <p className="text-xs text-orange-700 dark:text-orange-300">
                                    <AlertCircle size={12} className="inline mr-1" />
                                    <strong>Atenção:</strong> Ao sair, dados locais são limpos. Mantenha-se logado!
                                </p>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="bg-blue-50 dark:bg-blue-900/20 p-2.5 rounded-lg border border-blue-100 dark:border-blue-800">
                                <p className="text-xs text-blue-700 dark:text-blue-300">
                                    <Save size={12} className="inline mr-1" />
                                    <strong>Local + Nuvem:</strong> Salvos no navegador e sincronizados quando logado.
                                </p>
                            </div>

                            <div className="bg-orange-50 dark:bg-orange-900/20 p-2.5 rounded-lg border border-orange-100 dark:border-orange-800">
                                <p className="text-xs text-orange-700 dark:text-orange-300">
                                    <Globe size={12} className="inline mr-1" />
                                    <strong>Sync:</strong> A cada 5 min, dados vão para nuvem. Em novo dispositivo, basta logar.
                                </p>
                            </div>

                            <div className="bg-gray-50 dark:bg-gray-700 p-2.5 rounded-lg border border-gray-200 dark:border-gray-600">
                                <p className="text-xs text-gray-600 dark:text-gray-300">
                                    <AlertCircle size={12} className="inline mr-1" />
                                    <strong>Atenção:</strong> Ao sair, dados locais são limpos. Mantenha-se logado!
                                </p>
                            </div>
                        </>
                    )}
                </div>

                <button
                    onClick={onClose}
                    className="w-full py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white font-bold text-sm rounded-xl transition-colors"
                >
                    Entendi
                </button>
            </div>
        </div>,
        document.body
    );
};

export default DataStorageInfoModal;
